export class PriLabelEntity{
    id:number;
    name:string;
    prnCode:string;
    printCount:number;
    link:string;
    customerId:number;
    customer:string;
    sectionId:number;
    section:string;
    active:boolean;

    constructor(){}
}